export const locale = {
    lang: 'nl',
    data: {
        'PROJECTS': {
            'PROJECTS': 'Projecten'
        }
    }
};
